import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setgetQuestionsError, setLoading, setGeneralQuestionList } from "../../repository/slice";

function* getGeneralQuestionListWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/general-question", payload);
        if (isError) {
            yield put(setgetQuestionsError(message));
        } else {
            yield put(setgetQuestionsError(null));
            yield put(setGeneralQuestionList({list: data.rows, count: data.count}));
        }
    } catch (error) {
        console.error("getGeneralQuestionListWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getGeneralQuestionListWatcher() {
    yield takeLatest("@saga/GET_GENERAL_QUESTION_LIST", getGeneralQuestionListWorker);
};
